@if (coverages() && customers()) {
  <div class="cds-flex cds-flex-col sm:cds-m-3">
    <div class="coverageDetails">Coverage Details</div>
    <div class="cb-card__text">
      <div class="cds-flex cds-justify-between cds-items-center cds-mb-3">
        <p class="body-regular">Please ensure that the below information is correct.</p>
      </div>
    </div>

    <cb-accordion
      [multiple]="true"
      [value]="openAccordions"
      [variant]="'marketing'"
      [padding]="'large'"
      [cuePosition]="'right'"
      [cueType]="'caret'"
      [indent]="true"
      class="cds-pt-3">
      @for (coverage of coverages(); track coverage; let index = $index) {
        @if (customers()[customerIndex()] && customers()[customerIndex()].number === coverage.customerNumber) {
          <!--  1. Life Cover -->
          @if (coverage.type === coverageType.LIFE_COVER && coverage.code === coverageCode.uLife) {
            <cb-accordion-panel [id]="index" [attr.data-testid]="`coverage-accordion-${index}`">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-life-insurance"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <p class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</p>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <div class="coverage">
                  <app-assurance-extra-life-cover
                    [coverage]="coverage"
                    [customerIndex]="customerIndex()"
                    [coverageIndex]="index" />
                </div>
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  2. Trauma - Accelerated -->
          @if (coverage.type === coverageType.TRAUMA && coverage.code === coverageCode.uTraumaA) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-property-casulty"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      <!-- Display coverage code label -->
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-trauma-cover-accelerated
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  3. Trauma - Standalone -->
          @if (coverage.type === coverageType.TRAUMA && coverage.code === coverageCode.uTraumaS) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-property-casulty"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-trauma-cover-standalone
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  4. Moderate Trauma Accelerated -->
          @if (coverage.type === coverageType.TRAUMA && coverage.code === coverageCode.uTraumaA_MD) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-property-casulty"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-trauma-cover-accelerated-moderate
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  5. Moderate Trauma Standalone -->
          @if (coverage.type === coverageType.TRAUMA && coverage.code === coverageCode.uTraumaS_MD) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-property-casulty"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-trauma-cover-standalone-moderate
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  6. Child Trauma Cover -->
          @if (coverage.type === coverageType.TRAUMA_CHILD && coverage.code === coverageCode.uTraumaChild) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-trust"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-trauma-cover-child
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  7. Mortgage Repayment Cover -->
          @if (coverage.type === coverageType.MORTGAGE_REPAYMENT && coverage.code === coverageCode.uMRepaymentCov) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-house"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-mortgage-repayment-cover
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  8. Complete Disablement Accelerated -->
          @if (coverage.type === coverageType.COMPLETE_DISABLEMENT && coverage.code === coverageCode.uCompDisA) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-accident-health"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-disablement-accelerated
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  9. Complete Disablement Standalone -->
          @if (coverage.type === coverageType.COMPLETE_DISABLEMENT && coverage.code === coverageCode.uCompDisS) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-accident-health"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-disablement-standalone
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  10. Redundancy Cover -->
          @if (coverage.type === coverageType.REDUNDANCY_COVER && coverage.code === coverageCode.uRedundancy) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-claims-close"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-redundancy-cover [coverage]="coverage" [customerIndex]="customerIndex()" [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  11. Income Cover -->
          @if (
            (coverage.type === coverageType.INCOME_COVER && coverage.code === coverageCode.uIncome) ||
            (coverage.type === coverageType.LOSS_OF_EARNING && coverage.code === coverageCode.uLOE)
          ) {
            <cb-accordion-panel>
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-quote-new"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      Income Cover
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-income-cover [coverage]="coverage" [customerIndex]="customerIndex()" [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  12. Life Income Cover -->
          @if (coverage.type === coverageType.INCOME_COVER_LIFE && coverage.code === coverageCode.uLifeIncome) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-quote-new"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-income-cover-extra
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  13. Premium Cover -->
          @if (coverage.type === coverageType.PREMIUM_COVER && coverage.code === coverageCode.uPremium) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-claims-pay"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-premium-cover [coverage]="coverage" [customerIndex]="customerIndex()" [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
          <!--  14. Specific Injury Cover -->
          @if (coverage.type === coverageType.SPECIFIC_INJURY && coverage.code === coverageCode.uSpecificInjury) {
            <cb-accordion-panel [id]="'coverage-' + coverage.code">
              <cb-accordion-header>
                <div class="cds-w-full cds-flex cds-justify-between cds-items-center">
                  <div class="cds-flex cds-gap-2">
                    <cb-icon
                      iconKey="brand-workers-compensation"
                      iconSize="large"
                      iconColor="purple-branding"
                      [addPointerClass]="false" />
                    <p class="text-span">
                      {{ getValByCode('coverageCode', coverage.code) }}
                      @if (showCoverageErrors(customerIndex(), index).length > 0) {
                        <span class="required-asterisk">*</span>
                      }
                    </p>
                  </div>
                  <span class="coverage-status">{{ getValByCode('coverageStatusCode', coverage.statusCode) }}</span>
                </div>
              </cb-accordion-header>
              <cb-accordion-content>
                <app-specific-injury-cover
                  [coverage]="coverage"
                  [customerIndex]="customerIndex()"
                  [coverageIndex]="index" />
              </cb-accordion-content>
            </cb-accordion-panel>
          }
        }
      }
    </cb-accordion>
  </div>
}
